//@ts-check
import * as d3 from "d3";

/**
 * Register the events for selecting and highlighting the elements of the added 2D Viewer.
 * Use a predefined event name only to register the events. Event names are case-sensitive. Below are predefined names for events : 
 * 1. element-select - for selecting the elements
 * 2. element-highlight - for highlighting the element
 * @param {string} eventName Pass the predefined name of event to register the respective event. 
 * @param {Function} callBack Handle The callBack is a function at the consumer side as the element ID is getting returned through the callback function.
 * @returns {*} Returns the selected or highlighted element ID at consumer side callback function.
 * @returns {Object} It returns an object for acknowledgement of this API to the consumer side.
 */
export function registerEvent(eventName, callBack) {
  try {
    if ((eventName != undefined || eventName != null) && (callBack != undefined || callBack != null)) {
      let scope = this;
      switch (eventName) {
        case 'element-select':
          d3.select(scope.canvas).on('click', (e) => scope.pickElement(e, callBack), false);
          break;
        case 'element-highlight':
          d3.select(scope.canvas).on('mousemove', (e) => scope.highlightElement(e, callBack), false);
          break;
        case 'element-zoom':
          scope.zoomEvent = d3.select('#' + scope.canvas.id).select('svg').call(d3.zoom().on('zoom', (e) => scope.handleZoomEvent(e, callBack), false));
          break;
      }
      var returnValue = {
        'status': 'success',
        'message': 'Event registered on viewer successfully.'
      }
      return returnValue;
    }
    else {
      var returnValue = {
        'status': 'failed',
        'message': 'ERROR : Event name or callback is either undefined or null.'
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      'status': 'failed',
      'message': "System Error: " + err.message
    }
    return returnValue;
  }
}

/**
* Select Event
* @param {MouseEvent} event - Mouse event
* @param {Object} callBack  - call selected group.id on canvas
*/
export function pickElement(event, callBack) {
  let scope = this;
  if (!scope.multipleSelectionFlagCheck) {
    scope.clear_pickSelection();
  }
  let group = event.target.parentElement;
  if (group.id != scope.canvas.id && event.target.parentElement.tagName == 'g' && event.target.parentElement.id != 'labelGroup') {
    if (d3.select(scope.canvas).selectAll('#' + group.id).attr('status') != 'locked') {
      scope.arrayElements.push(group.id);
      scope.applySelection(group.id);
      callBack([group.id, event.target.nearestViewportElement.id]);
    }
  } else {
    callBack('');
    scope.clear_pickSelection();
  }
}

/**
 * Hightlight Event
 * @param {MouseEvent} event - Mouse event
 * @param {Object} callBack - call back intersected object name
 * @returns {Object} Return success or error messages 
 * { status:  mesage: }
 */
export function highlightElement(event, callBack) {
  let scope = this;
  if (scope.highlightElementFlagCheck) {
    scope.clear_highlightSelection();
    var group = event.target.parentElement;
    if (group.id != null) {
      if (group.id != scope.canvas.id
        && event.target.parentElement.tagName == 'g') {
        if (d3.select(scope.canvas).selectAll('#' + group.id).attr('status') != 'locked') {
          scope.applyHighlight(group.id);
          this.applyToolTip(event, group.id);
          callBack(group.id);
        }
      }
      else {
        callBack(null);
      }
    }
    else {
      var returnValue = {
        "status": "failed",
        "message": "ERROR : Event or callback is either undefined or null."
      }
      return returnValue;
    }
  }
}